import axios from "axios";
import { useEffect } from "react";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("s360_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatPrice = (p) =>
  p == null
    ? null
    : new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(p);

export const BADGES = {
  favorito: { label: "Favorito", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  oferta: { label: "Merece la pena", cls: "bg-red-50 text-red-700 border-red-200" },
  nuevo: { label: "Novedad", cls: "bg-blue-50 text-blue-700 border-blue-200" },
};

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -130 });
  else el.scrollIntoView({ behavior: "smooth" });
}

export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
  }, [title, description]);
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}
